import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components';
import { Button, TextField, Grid, MenuItem, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { makeStyles } from '@mui/styles';
import PageTitle from '../../../shared/components/PageTitle';
import config from '../../config.json';
import { Formik } from 'formik';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addUpdateUser, getManagerList, getOrgList, getUserId } from '../../api';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(0),
  },
  withoutLabel: {
    marginTop: theme.spacing(0),
  },
  customToastProgress: {
    backgroundColor: '#F59300',
  },
}));

const UserWrapper = styled.div`
    position: relative;
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
        background-color: #F59300 !important;
    }
    .css-1rwt2y5-MuiButtonBase-root-MuiButton-root {
        border : 1px solid #F59300 !important;
        color : #F59300 !important;
    }

    .wrapperWhite {
        background-color: #ffffff;
        padding: 1.5rem;
        border-radius: 18px;
    }

    .MuiTextField-root {
        width: 100%;
    }

    .card-box{
        position: relative;
        overflow: hidden;
        box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
        border-radius: 0.5rem;
        color: rgba(0, 0, 0, 0.87);
        transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        background-color: #fff;        
        cursor: pointer;
    }
    .card-indicator {
        position: absolute;
        height: 60%;
        top: 20%;
        width: 0px;
        border-top-right-radius: .75rem;
        border-bottom-right-radius: .75rem;
        left: 0;
        transition: all 0.3s linear;
    }
    .badge-primary {
        color: #fff;
        font-weight: 500;    
    }
    .roleName {
        font-size: 14px;
        font-weight: 500;
    }
    .roleItems { 
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
    .roleItems:checked ~ .card-indicator {
        width: 6px;
    }
    .customWidth : {
        width : 100% !important
    }
`;

export default function AddSuperAdminUserProfile() {
  const classes = useStyles();
  const { id } = useParams();
  const token = config.TOKEN;
  const navigate = useNavigate();
  var [rows, setRows] = React.useState(
    {
      firstName: "",
      userEmail: "",
      pwd: "",
      confirmPassword: "",
      userType: "",
      orgId: ""
    }
  );
  var [isSupervisor, setIsSupervisor] = React.useState(false);
  var [portalLogin, setPortalLogin] = React.useState(false);
  var [isProfilePicChanged, setIsProfilePicChanged] = React.useState(false);
  var [isSignaturePicChanged, setIsSignaturePicChanged] = React.useState(false);
  var [orgIdList, setOrgIdList] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const userType = ["SUPER_ADMIN", "ADMIN"];
  const addUserProfile = () => toast("User Profile Added Successfully!", { progressClassName: classes.customToastProgress });
  const updateUserProfile = () => toast("User Profile Updated Successfully!", { progressClassName: classes.customToastProgress });
  const errorMessage = () => toast("An error occured, try again later!", { progressClassName: classes.customToastProgress });

  React.useEffect(() => {
    const fetchUserProfile = async () => {
      if (id) {
        try {
          const res = await getUserId(id)
          if (res.data.successCode === 0) {
            rows = res.data.data
            setRows(rows);
          } else {
            errorMessage();
          }
        } catch (err) {
          errorMessage();
        }
      }
    }
    fetchUserProfile();
    fetchOrgList();
  }, [])

  const fetchOrgList = async () => {
    try {
      const res = await getOrgList();
      if (res.data.successCode === 1) {
        orgIdList = res.data.data.filter((a) => a.isActive === true)
        setOrgIdList(orgIdList);
      } else {
        errorMessage();
      }
    } catch (err) {
      errorMessage();
    }
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          FirstName: rows?.firstName,
          UserEmail: id ? rows?.userEmail : "",
          Pwd: rows?.pwd,
          ConfirmPassword: id ? rows?.pwd : "",
          userType: rows?.userType,
          orgId: rows?.orgId
        }}
        validate={values => {
          const errors = {}
          if (!values.FirstName) {
            errors.FirstName = "Required!"
          }
          if (!values.UserEmail) {
            errors.UserEmail = "Required!"
          }
          if (!values.Pwd) {
            errors.Pwd = "Required!"
          }
          if (values.Pwd !== values.ConfirmPassword) {
            errors.ConfirmPassword = "Passwords do not match!"
          }
          if (!values.userType) {
            errors.userType = "Required!"
          }
          if (values.userType == "ADMIN") {
            if (!values.orgId) {
              errors.orgId = "Required!"
            }
          }
          return errors;
        }}

        const handleMouseDownPwd={(event) => {
          event.preventDefault();
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const postData = {
            id: id ? id : 0,
            firstName: values.FirstName,
            userEmail: values.UserEmail,
            pwd: values.Pwd,
            userType: values.userType,
            orgId: values.orgId.toString() || ""
          }

          try {
            const res = await addUpdateUser(postData);
            if (res.data.successCode === 0) {
              { id ? updateUserProfile() : addUserProfile() }
            } else {
              errorMessage();
            }
            setTimeout(() => { navigate("/user/profile/list") }, 3000)
          } catch (err) {
            errorMessage();
            setTimeout(() => { navigate("/user/profile/list") }, 3000)
          }
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <UserWrapper>
              <ToastContainer theme="dark" />
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                  <PageTitle> User Profile </PageTitle>
                </Grid>
                <Grid item xs={12} sm={6} md={6} className="text-right">

                </Grid>
              </Grid>
              <br></br>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6} className="pt-3">
                  <TextField label="Name" variant="standard" name="FirstName" value={values.FirstName || ""} onChange={handleChange} onBlur={handleBlur} />
                  <span className="errMsg">{errors.FirstName && touched.FirstName && errors.FirstName}</span>
                </Grid>
                <Grid item xs={12} sm={6} md={6} className="pt-3">
                  <TextField label="Email" variant="standard" name="UserEmail" value={values.UserEmail || ""} onChange={handleChange} onBlur={handleBlur} autoComplete="new-email" />
                  <span className="errMsg">{errors.UserEmail && touched.UserEmail && errors.UserEmail}</span>
                </Grid>
              </Grid>
              <br></br>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField label="Password" variant="standard" name="Pwd" type={showPassword ? "text" : "password"} value={values.Pwd || ""} onChange={handleChange} onBlur={handleBlur} autoComplete="new-password" InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }} />
                  <span className="errMsg">{errors.Pwd && touched.Pwd && errors.Pwd}</span>
                </Grid>
                <Grid item xs sm={6} md={6}>
                  <TextField label="Retype Password" variant="standard" name="ConfirmPassword" type={showConfirmPassword ? "text" : "password"} value={values.ConfirmPassword || ""} onChange={handleChange} onBlur={handleBlur} autoComplete="new-password" InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }} />
                  <span className="errMsg">{errors.ConfirmPassword && touched.ConfirmPassword && errors.ConfirmPassword}</span>
                </Grid>
              </Grid>
              <br></br>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    style={{ width: "99%" }}
                    className="filterDropdown"
                    id="status"
                    select
                    label="Select UserType"
                    helperText=""
                    variant="standard"
                    name="userType"
                    value={values.userType || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}>
                    {userType.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                  <span className="errMsg">{errors.userType && touched.userType && errors.userType}</span>
                </Grid>
                {values.userType == "ADMIN" && (<Grid item xs={12} sm={6} md={6}>
                  <TextField
                    style={{ width: "90%" }}
                    id="orgId"
                    name="orgId"
                    className="filterDropdown"
                    select label="Select Org"
                    helperText=""
                    variant="standard"
                    value={values.orgId || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    {orgIdList.map(option => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                  <span className="errMsg">{errors.orgId && touched.orgId && errors.orgId}</span>
                </Grid>)}
              </Grid>
              <br></br>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={12} md={12} className="text-right mt-4">
                  <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => navigate("/userProfile/list")}>
                    Cancel
                  </Button>&nbsp;&nbsp;
                  <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" disabled={isSubmitting}>
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </UserWrapper>
          </form>
        )}
      </Formik>
    </>
  )
}
